import { calculateTimeDifference, getDefaultAnalyticsLabel } from "../layout2.0/JS/utility";

export const playDoorCameraStream = (videoUrl, props, channelName) => {
    if(!videoUrl){
        props.popupOpenClose(true, "Channel Stream not available");
        return;
    }
    // videoUrl = 'http://techslides.com/demos/sample-videos/small.mp4'
    let videoStartTime = new Date
    console.log("videoUrl", videoUrl);
    if (window.cordova || window.device) {
        if (window.device.platform === "Android" || window.device.platform === "iOS") {
            console.log("window.VideoPlayerVLC", window.VideoPlayerVLC);
            //this.props.popupOpenClose(true, videoUrl);
            try{
                // Send Analytics
                let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
                    props.sendAnalytics(
                        props.guestDetail, 
                        props.currentWidgetOb, 
                        "VIDEO_PLAYER_STARTED", 
                        {...label, "channelName": channelName},
                        0, 
                        props.guestIsLoggedIn
                    );    
                window.VideoPlayerVLC.play(
                    videoUrl,
                    (done) => { 
                        console.log("successfully launched the VLC", done, typeof done, done == "onDestroyVlc") 
                        if(done == 'onError' || done == 'onStopVlc'){
                            props.popupOpenClose(true, 'Sorry currenlty this channel stream is not available')
                            if(window.FireBasePlugin){
                                // window.FirebasePlugin.logMessage("Error in calling the deviceConfig using getClientConfig() session token = " + sessionToken);
                                window.FirebasePlugin.logError("Error in playing stream in VLC Player " + done)
                            }
                            let videoEndTime = new Date
                            let duration = calculateTimeDifference(videoStartTime, videoEndTime, 'minute');
                            let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
                            props.sendAnalytics(
                                props.guestDetail, 
                                props.currentWidgetOb, 
                                "ERROR_IN_PLAYING_VIDEO", 
                                {...label, "channelName": channelName},
                                duration, 
                                props.guestIsLoggedIn
                            );    
                        } 
                        if(done == "onDestroyVlc"){
                            // Send Analytics
                            console.log("in destry vlc")
                                let videoEndTime = new Date
                                let duration = calculateTimeDifference(videoStartTime, videoEndTime, 'minute');
                                let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
                                if( duration >= props.minimumChannelWatchDuration){
                                    props.sendAnalytics(
                                        props.guestDetail, 
                                        props.currentWidgetOb, 
                                        "VIDEO_PLAYER_STOPED", 
                                        {...label, "channelName": channelName}, 
                                        duration, 
                                        props.guestIsLoggedIn
                                    );    
                                }                                //
                        }
                    },
                    (error) => { 
                        console.log("error in launching the VLC : ", error) 
                        props.popupOpenClose(true, 'Sorry currenlty this channel stream is not available')
                        if(window.FireBasePlugin){
                            // window.FirebasePlugin.logMessage("Error in calling the deviceConfig using getClientConfig() session token = " + sessionToken);
                            window.FirebasePlugin.logError("Error in launching VLC Player" + error)
                        }
                    }
                );
                } catch (error) {
                    console.log('error in launching VLC', error)
                    if(window.FirebasePlugin){
                        window.FirebasePlugin.logError("error in launching VLC", error )
                    }
                }
        }
    } else {
        // console.log("this feature is not available for desktop.");
        props.popupOpenClose(true, "This feature is not available for desktop.");
    }
}